import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { RouterModule } from '@angular/router';
import { Ng5SliderModule } from 'ng5-slider';

import { CreateFunctionalAnalysisTemplateModalComponent } from '../../../functional-analyses/functional-analysis-template/create-functional-analysis-template-modal/create-functional-analysis-template-modal.component';
import { ImportEntitiesModalComponent } from '../../../entity/import-entities-modal/import-entities-modal.component';
import {
  ImportTransactionsModalComponent
} from '../../../transaction/import-transactions-modal/import-transactions-modal.component';
import {
  EntityCurrencyConversionModalComponent
} from '../../../master-file/entity-currency-conversion-modal/entity-currency-conversion-modal.component';
import { ModifyPbaFunctionalAnalysisTemplateModalComponent } from '../../../functional-analyses/functional-analysis-template/modify-pba-functional-analysis-template-modal/modify-pba-functional-analysis-template-modal.component';
import { ModifyTbaFunctionalAnalysisTemplateModalComponent } from '../../../functional-analyses/functional-analysis-template/modify-tba-functional-analysis-template-modal/modify-tba-functional-analysis-template-modal.component';
import { ModifyUncontrolledFunctionalAnalysisTemplateModalComponent } from '../../../functional-analyses/functional-analysis-template/modify-uncontrolled-functional-analysis-template-modal/modify-uncontrolled-functional-analysis-template-modal.component';
import { ReportGenerationModalComponent } from '../../../master-file/working-master-file-repository/report-generation-modal/report-generation-modal.component';
import { MessageModalComponent } from '../../components/message/message-modal.component';
import { AlertChangeContainerModal, ChangeContainerModal, ConfirmationModalComponent } from '../modal';
import { ConfirmationModalFormComponent } from '../modal';
import {
  AddSubtopicModalComponent
} from '../../components/background-info/add-subtopic-modal/add-subtopic-modal.component';
import {
  CopyBackgroundInfoModalComponent
} from '../../components/background-info/copy-background-info-modal/copy-background-info-modal.component';
import {
  ImportBackgroundInfoTemplateComponent
} from '../../components/background-info/import-background-info-template/import-background-info-template.component';
import {
  CreateTemplateModalComponent
} from '../../components/background-info/create-template-modal/create-template-modal.component';
import {
  TransactionModalComponent
} from '../../../transaction/transaction-modal/transaction-modal.component';
import {
  EvaluateServiceTransactionComponent
} from '../../../transaction/evaluate-service-transaction/evaluate-service-transaction.component';
import {
  UncontrolledTransactionModalComponent
} from '../../../local-files/uncontrolled-components/uncontrolled-transaction/uncontrolled-transaction-modal.component';
import { EntityModalComponent } from '../../../entity/entity-modal/entity-modal.component';
import { ExportEntityDataModal } from '../../../entity/export-entity-data-modal/export-entity-data-modal.component';
import { AddDocumentModalComponent } from '../../../entity/add-document-modal/add-document-modal.component';
import {
  GenerateReportModalComponent
} from '../../../entity/working-entity-repository/generate-report-modal/generate-report-modal.component';
import { StudyModalComponent } from '../../../study/study-modal/study-modal.component';
import {
  AddTransactionsModalComponent as AddPbaTransactionsModalComponent
} from '../../../study/profit-based-analyses/add-transactions-modal/add-transactions-modal.component';
import {
  AddTransactionsModalComponent
} from '../../../study/current-study/study-setup/add-transactions-modal/add-transactions-modal.component';
import {
  CreatePbaModalComponent
} from '../../../study/profit-based-analyses/create-pba-modal/create-pba-modal.component';
import {
  EditPbaModalComponent
} from '../../../study/profit-based-analyses/edit-pba-modal/edit-pba-modal.component';
import {
  TestedPartyModalComponent
} from '../../../study/profit-based-analyses/tested-party-modal/tested-party-modal.component';
import {
  TbaModalComponent
} from '../../../study/transaction-based-analyses/tba-modal/tba-modal.component';
import {
  AddAdjustmentTypeModalComponent
} from '../../../study/transaction-based-analyses/add-adjustment-type-modal/add-adjustment-type-modal.component';
import {
  ApplyAdjustmentModalComponent
} from '../../../study/transaction-based-analyses/apply-adjustment-modal/apply-adjustment-modal.component';
import {
  EffectivenessModalComponent
} from '../../../study/transaction-based-analyses/effectiveness-modal/effectiveness-modal.component';
import {
  EvaluateComparabilityModalComponent
} from '../../../study/transaction-based-analyses/evaluate-comparability-modal/evaluate-comparability-modal.component';
import {
  DetermineAcceptanceModalComponent
} from '../../../study/transaction-based-analyses/determine-acceptance-modal/determine-acceptance-modal.component';
import {
  RangeTypeModalComponent
} from '../../../study/transaction-based-analyses/range-type-modal/range-type-modal.component';
import {
  DiscussRangeResultsModalComponent as TbaDiscussRangeResultsModalComponent
} from '../../../study/transaction-based-analyses/discuss-range-results-modal/discuss-range-results-modal.component';
import {
  CreateCompPoolModalComponent
} from '../../../study/comp-search/create-comp-pool-modal/create-comp-pool-modal.component';
import {
  EditEconomicsAnalysisModalComponent
} from '../../../study/comp-search/edit-economics-analysis-modal/edit-economics-analysis-modal.component';
import {
  AddCharacteristicModalComponent
} from '../../../functional-analyses/add-characteristic-modal/add-characteristic-modal.component';

import {
  DiscussFinalRangeResultsModalComponent
} from '../../../study/comp-search/third-party-data-selection/discuss-final-range-results-modal/discuss-final-range-results-modal.component';
import {
  UncontrolledEntityModalComponent
} from '../../../local-files/uncontrolled-components/uncontrolled-entity/uncontrolled-entity-modal/uncontrolled-entity-modal.component';

import {
  UncontrolledEntityImportModalComponent
} from '../../../local-files/uncontrolled-components/uncontrolled-entity/uncontrolled-import-entity-modal/uncontrolled-entity-import-modal.component';
import {
  AddControlledTransactionsModalComponent
} from '../../../study/transaction-based-analyses/add-controlled-transactions-modal/add-controlled-transactions-modal.component';
import {
  AddUncontrolledTransactionsModalComponent
} from '../../../study/transaction-based-analyses/add-uncontrolled-transactions-modal/add-uncontrolled-transactions-modal.component';
import {
  ApplyCapitalAdjustmentsModalComponent
} from '../../../study/comp-search/third-party-data-selection/apply-capital-adjustments-modal/apply-capital-adjustments-modal.component';
import {
  EvaluateComparableModalComponent
} from '../../../study/comp-search/third-party-data-selection/evaluate-comparable-modal/evaluate-comparable-modal.component';
import {
  ProvideTransactionFxaDetailsModalComponent
} from '../../../functional-analyses/provide-transaction-fxa-details-modal/provide-transaction-fxa-details-modal.component';
import {
  ProvideDescriptionModalComponent
} from '../../../study/profit-based-analyses/current-pba/tested-party-characterization/provide-description-modal/provide-description-modal.component';
import {
  ProvideCodesModalComponent
} from '../../../study/profit-based-analyses/current-pba/tested-party-characterization/provide-codes-modal/provide-codes-modal.component';
import {
  ProvideFeaturesModalComponent
} from '../../../study/profit-based-analyses/current-pba/tested-party-characterization/provide-features-modal/provide-features-modal.component';
import {
  ProvideClassificationsModalComponent
} from '../../../study/profit-based-analyses/current-pba/tested-party-characterization/provide-classifications-modal/provide-classifications-modal.component';
import {
  MinorClassificationsModalComponent
} from '../../../study/profit-based-analyses/current-pba/tested-party-characterization/minor-classifications-modal/minor-classifications-modal.component';
import {
  FinancialsDataModalComponent
} from '../../../entity/entity-financials/financials-table/financials-data-modal/financials-data-modal.component';
import { TransactionMethodEvaluationModalComponent } from '../../../transaction/transaction-method-evaluation-modal/transaction-method-evaluation-modal.component';
import { TransactionNotAppliedMethodEvaluationModalComponent } from '../../../transaction/transaction-na-method-evaluation-modal/transaction-na-method-evaluation-modal.component';
import { FlowChartModalComponent } from 'src/app/entity-dashboard/flow-chart-modal/flow-chart-modal.component';
import { ReportVersionModalComponent } from '../../../entity/working-entity-repository/report-version-modal/report-version-modal.component';
import { EditInternalLocalfileReportTitleModalComponent } from '../../../entity/working-entity-repository/edit-internal-localfile-report-title-modal/edit-internal-localfile-report-title-modal.component';
import { ReCycleSearchModalComponent } from '../../../study/comp-search/third-party-data-selection/re-cycle-search-modal/re-cycle-search-modal.component';
import { PlanningEntityModalComponent } from '../../../planning/planning-entity-modal/planning-entity-modal.component';
import { PlanningFinancialModalComponent } from '../../../planning/planning-financial-modal/planning-financial-modal.component';
import { TransactionAndTestedPartyComponent } from '../../../planning/planning-financial-modal/transaction-and-tested-party/transaction-and-tested-party.component';
import { FinancialDetailsComponent } from '../../../planning/planning-financial-modal/financial-details/financial-details.component';
import { TaxRateComponent } from '../../../planning/planning-financial-modal/tax-rate/tax-rate.component';
import { RiskSettingsComponent } from '../../../planning/planning-financial-modal/risk-settings/risk-settings.component';
import { PlanningNewScenarioModalComponent } from '../../../planning/planning-view-toggle/planning-new-scenario-modal/planning-new-scenario-modal.component';
import { UploadReportVersionModalComponent } from '../../../entity/working-entity-repository/upload-report-version-modal/upload-report-version-modal.component';
import { UploadMasterFileReportVersionModalComponent } from '../../../master-file/working-master-file-repository/upload-master-file-report-version-modal/upload-master-file-report-version-modal.component';
import { EditReportTitleModalComponent } from '../../../shared/components/reports/working-report-repository/edit-report-title-modal/edit-report-title-modal.component';
import { DropdownsModalComponent } from '../../components/dropdowns-modal/dropdowns-modal.component';
import { SaveCompSearchModalComponent } from '../../../study/comp-search/tune-comparable-search/save-comp-search-modal/save-comp-search-modal.component';
import { LoadCompSearchModalComponent } from '../../../study/comp-search/tune-comparable-search/load-comp-search-modal/load-comp-search-modal.component';
import { DeleteCompSearchModalComponent } from '../../../study/comp-search/tune-comparable-search/delete-comp-search-modal/delete-comp-search-modal.component';

import { CreateLocalFileReportModalComponent } from '../../../local-file/jurisdiction-repository/create-add-version-local-file/create-local-file-report-modal.component';
import { UploadLocalFileReportModalComponent } from '../../../local-file/jurisdiction-repository/upload-local-file-report/upload-local-file-report-modal.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { UncontrolledTransactionsImportModalComponent } from '../../../local-files/uncontrolled-components/uncontrolled-transaction/uncontrolled-transactions-import-modal/uncontrolled-transactions-import-modal.component';
import { EditPLISettingsModalComponent } from '../../../study/comp-search/tune-comparable-search/edit-pli-settings-modal/edit-pli-settings-modal.component';
import { OrgChartSummaryModalComponent } from '../../components/reports/working-report-repository/org-chart-summary-modal/org-chart-summary-modal.component';

const components = [
  CreateFunctionalAnalysisTemplateModalComponent,
  ImportEntitiesModalComponent,
  ImportTransactionsModalComponent,
  UncontrolledTransactionsImportModalComponent,
  MessageModalComponent,
  ModifyPbaFunctionalAnalysisTemplateModalComponent,
  ModifyTbaFunctionalAnalysisTemplateModalComponent,
  ModifyUncontrolledFunctionalAnalysisTemplateModalComponent,
  ConfirmationModalComponent,
  AlertChangeContainerModal,
  ChangeContainerModal,
  ConfirmationModalFormComponent,
  AddSubtopicModalComponent,
  CopyBackgroundInfoModalComponent,
  ImportBackgroundInfoTemplateComponent,
  CreateTemplateModalComponent,
  TransactionModalComponent,
  EvaluateServiceTransactionComponent,
  UncontrolledEntityModalComponent,
  UncontrolledEntityImportModalComponent,
  UncontrolledTransactionModalComponent,
  EntityModalComponent,
  ExportEntityDataModal,
  AddDocumentModalComponent,
  GenerateReportModalComponent,
  StudyModalComponent,
  AddTransactionsModalComponent,
  CreatePbaModalComponent,
  EditPbaModalComponent,
  TestedPartyModalComponent,
  AddPbaTransactionsModalComponent,
  TbaModalComponent,
  AddControlledTransactionsModalComponent,
  AddUncontrolledTransactionsModalComponent,
  AddAdjustmentTypeModalComponent,
  ApplyAdjustmentModalComponent,
  EffectivenessModalComponent,
  EvaluateComparabilityModalComponent,
  DetermineAcceptanceModalComponent,
  RangeTypeModalComponent,
  TbaDiscussRangeResultsModalComponent,
  DiscussFinalRangeResultsModalComponent,
  CreateCompPoolModalComponent,
  ApplyCapitalAdjustmentsModalComponent,
  EvaluateComparableModalComponent,
  EditEconomicsAnalysisModalComponent,
  ProvideTransactionFxaDetailsModalComponent,
  AddCharacteristicModalComponent,
  ProvideDescriptionModalComponent,
  ProvideCodesModalComponent,
  ProvideFeaturesModalComponent,
  ProvideClassificationsModalComponent,
  MinorClassificationsModalComponent,
  EntityCurrencyConversionModalComponent,
  FinancialsDataModalComponent,
  TransactionMethodEvaluationModalComponent,
  TransactionNotAppliedMethodEvaluationModalComponent,
  FlowChartModalComponent,
  ReportVersionModalComponent,
  UploadReportVersionModalComponent,
  EditInternalLocalfileReportTitleModalComponent,
  ReCycleSearchModalComponent,
  PlanningEntityModalComponent,
  PlanningFinancialModalComponent,
  TransactionAndTestedPartyComponent,
  FinancialDetailsComponent,
  TaxRateComponent,
  RiskSettingsComponent,
  PlanningNewScenarioModalComponent,
  ReportGenerationModalComponent,
  UploadMasterFileReportVersionModalComponent,
  EditReportTitleModalComponent,
  OrgChartSummaryModalComponent,
  DropdownsModalComponent,
  SaveCompSearchModalComponent,
  LoadCompSearchModalComponent,
  EditPLISettingsModalComponent,
  DeleteCompSearchModalComponent,
  CreateLocalFileReportModalComponent,
  UploadLocalFileReportModalComponent,
];

@NgModule({
  imports: [
    FormsModule,
    TranslateModule,
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    Ng5SliderModule,
    RouterModule,
    EditorModule,
  ],
  declarations: [
    ...components,
  ],
  entryComponents: [
    ...components,
  ],
  exports: [
    ...components,
  ],
})
export class EntryComponentsModule { }
